<template>
  <shortlist-drawer class="shortlist" anchored="left" :class="{ 'is-active' : expanded }" :style="getShortlistPosition">
    <div class="shortlist-top">
      <p class="h3 uppercase">
        My shortlist
      </p>
      <font-awesome-icon :icon="['fas', 'ellipsis-v']" size="sm" class="more-dots" aria-label="shortlist heart" @click="removePropagation($event); showMoreOptions = !showMoreOptions" />
      <div v-show="showMoreOptions" class="more-options">
        <app-link id="16" type="page" class="more-options-add router-link text-dark">
          Add villas
        </app-link>
        <p v-if="!isShortlistEmpty" class="more-options-clear text-dark" @click="removePropagation($event); clearShortlist() ">
          Clear list
        </p>
        <p v-if="isShortlistEmpty" class="more-options-clear text-grey">
          Clear list
        </p>
      </div>
    </div>
    <template v-if="!isShortlistEmpty">
      <div class="shortlist-items" @scroll="onScroll($event)">
        <ShortlistItem v-for="villa in shortlistItems"
                       :id="villa.id"
                       :key="villa.id"
                       :villa="villa"
                       :name="villa.name"
                       :thumbnail="encode(villa.thumb || villa.img || villa.img1 || villa.img2)"
                       :dest="villa.dest"
                       :loc="villa.loc"
                       :sleeps="villa.sleeps"
                       :baths="villa.baths"
                       :beds="villa.beds"
                       :url="villa.url"
        />
      </div>
      <div class="shortlist-btns-wrapper">
        <a class="shortlist-btns btn-primary-dark-sm" @click.prevent="navigateToPage(41 ,'page')">Send us your shortlist</a>
        <a class="shortlist-btns btn-secondary-dark-sm" @click.prevent="navigateToPage(PAGE_IDS.SHARED_SHORTLIST ,'page')">Share shortlist</a>
      </div>
    </template>
    <template v-else>
      <div class="shortlist-empty">
        <p>Your Shortlist is empty. Click the heart icon on the villas you love to add them to your Shortlist.</p>
        <a class="shortlist-btns-empty btn-primary-dark-sm" @click.prevent="navigateToPage(16 ,'page')">Add villas</a>
      </div>
    </template>
  </shortlist-drawer>
</template>

<script>

import ShortlistDrawer from './ShortlistDrawer';
import ShortlistItem from './ShortlistItem';
import encode from '../../../mixins/encode';
import translateUrl from '../../../mixins/translateUrl';
import { PAGE_IDS } from '../../../constants/templates.js';
import routerLink from '../../../mixins/routerLink';
import responsive from '../../../mixins/responsive';

export default {
  components: {
    ShortlistDrawer,
    ShortlistItem,
  },
  mixins: [encode, translateUrl, routerLink, responsive],
  props: {
    expanded: Boolean,
  },
  data() {
    return {
      isMounted: false,
      showMoreOptions: false,
      PAGE_IDS,
      shortlistPositionTop: 56,
    };
  },
  computed: {
    shortlistItems() {
      return this.$store.getters['common/getShortlist'];
    },
    isShortlistEmpty() {
      return this.$store.getters['common/getShortlist'].length === 0 || false;
    },
    getShortlistWidth() {
      // wrong calculation - coming out as 1920 on mobile
      const gap = 40; // gap between left border and shortlist
      return `${this.$store.getters['common/getShortlistWidth'] - gap}px`;
    },
    isNavFixed() {
      return this.$store.getters['common/getNavfixed'];
    },
    getShortlistPosition() {
      return {
        width: this.isMobile ? '100%' : '320px',
        top: `${this.shortlistPositionTop}px`,
        left: this.isMobile ? '0px' : 'auto',
      };
    },
  },
  watch: {
    isNavFixed(n) {
      this.calculatePositions();
    },
  },
  mounted() {
    this.isMounted = true;
    this.calculatePositions();
  },
  methods: {
    onScroll(ev) {
      ev.stopPropagation();
    },
    sendShortlist(ev) {
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      const shortlist = this.$store.getters['common/getShortlist'];
    },
    browseAll(ev) {
      if (ev) {
        ev.stopPropagation();
      }
      this.$root.$refs.searchvillabtn.click(); // perform search
    },
    removePropagation(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    },
    clearShortlist() {
      this.$store.dispatch('common/clearShortlist');
      this.showMoreOptions = false;
    },
    calculatePositions() {
      if (this.isDesktop && this.isNavFixed) {
        this.shortlistPositionTop ? 111 : 56;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../../../assets/styles/settings/config.scss";

.shortlist {
  position: absolute;
  right: 15px;
  left: auto;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  height: auto;
  opacity: 0;
  // @media screen and (min-width : 360px) and (max-width : 599px) {
  //   right: -50px;
  //   }
  @media (min-width: 420px) {
    right: 2em;
  }
  @media (min-width: 1024px) {
    right: 5em;
  }

  &.is-active {
    opacity: 1;
  }

  &-top {
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 100%;
    padding: 10px 15px 0 15px;
    cursor: default;

    .more-dots {
      cursor: pointer;
    }

    .more-options {
      position: absolute;
      top: 30px;
      right: 15px;
      background-color: $stoneWhite;
      width: 225px;
      padding: 10px 20px;
      z-index: 2;
      border-radius: 4px;
      box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.3);

      &-add,
      &-clear {
        font-size: 16px;
        font-weight: normal;
        // to increase the click area on mobile
        display: block;
      }

      &-clear {
        margin-top: 15px;
        margin-bottom: 0;
        cursor: pointer;
      }
    }
  }

  &-items {
    max-height: 290px;
    overflow-x: hidden;
    flex-flow: column nowrap;
    overflow-y: scroll;
    align-items: center;
    a {
      padding: 0 0.5em 0.5em;
    }
  }

  &-btns {
    width: 100%;

    &-wrapper {
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;
      padding: 10px 15px;
      width: 100%;

      a:first-of-type {
        margin-bottom: 10px;
      }
    }

    &-empty {
      width: 100%;
    }
  }

  &-empty {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      color: $mortar;
      font-weight: 400;
      font-size: 1rem;
      text-align: center;
      padding: 20px 15px;
    }
  }
}

//   @media (max-width: 320px) {
//   .shortlist .is-right .is-active {
//     right: -15px !important;
//   }
// }

</style>
